import axios from "./axios";

/**
 * Tier 2 bulk signup helper.
 * Accepts either (userId, usersArray) or a single payload object { userId, users }.
 * Each user in usersArray should be { FirstName, LastName, Email, Password, Occupation?, Version? }.
 */
export const TierTWOsignUpBulk = async (arg1, arg2) => {
  try {
    let userId;
    let users;

    if (typeof arg1 === "object" && arg1 !== null && arg2 === undefined) {
      userId = arg1.userId;
      users = arg1.users;
    } else {
      userId = arg1;
      users = arg2;
    }

    if (!userId) throw new Error("userId is required");
    if (!Array.isArray(users) || users.length === 0) throw new Error("users must be a non-empty array");

    const payload = {
      userId: Number(userId),
      users: users.map(u => ({
        FirstName: u.FirstName || u.firstName || "",
        LastName: u.LastName || u.lastName || "",
        Email: u.Email || u.email,
        Password: u.Password || u.password,
        Occupation: u.Occupation || "other",
        Version: u.Version || "GPT"
      }))
    };

    const response = await axios.post("/Tier2signup", payload);
    return response;
  } catch (err) {
    throw err;
  }
};